export * from './speciality-management/speciality-management.component';
export * from './speciality-form/speciality-form.component';
